import { memo } from 'react';
import { clsx } from 'clsx';
import { tunnels } from 'modules/editor/tunnels';

import { useSelector } from 'app/store';
import { settingsIsCountryRestrictedSelector } from 'modules/settings/slice';
import RestrictedCountryDialog from 'modules/editor/components/RestrictedAreaDialog';
import { CoverageLegend } from 'modules/editor/components/CoverageLegend/CoverageLegend';
import { LinkTooltip } from '../containers/LinkTooltip';
import { Tools } from './Tools';

import classes from './Overlays.module.scss';

function OverlaysImp() {
  const isRestrictedCountry = useSelector(settingsIsCountryRestrictedSelector);

  return (
    <div className={classes.Overlays}>
      {isRestrictedCountry && <RestrictedCountryDialog />}

      <Tools className={classes.topLeft} />
      <CoverageLegend className={clsx(classes.overlayItem, classes.topRight)} />
      <LinkTooltip />

      <tunnels.overlay.Out />
    </div>
  );
}

export const Overlays = memo(OverlaysImp);
